const CONTACT_API_URL = process.env.REACT_APP_CONTACT_API_URL || 'https://5kdsze9xs4.execute-api.eu-central-1.amazonaws.com/contact';
const ACADEMIC_API_URL = process.env.REACT_APP_ACADEMIC_API_URL || 'https://o0vnudbmyc.execute-api.eu-central-1.amazonaws.com';

export interface RequestPricingResponse {
  success: boolean;
  message: string;
  error?: string;
}

class RequestPricingService {
  async requestPricingFromProfile(userEmail: string, userName?: string, userCompany?: string, userRole?: string): Promise<RequestPricingResponse> {
    try {
      const tagResponse = await fetch(`${ACADEMIC_API_URL}/add-pricing-tag`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          email: userEmail,
          tagId: '6925'
        }),
      });

      if (!tagResponse.ok) {
        console.error('Failed to add Active Campaign tag');
      }

      const messageInfo = {
        name: userName || 'Unknown',
        email: userEmail,
        organization: userCompany || 'Unknown',
        role: userRole || 'Unknown',
        message: "This user has completed a free trial. They have clicked the 'request pricing' button inside their account and would like to receive a quotation",
        subject: 'TRIAL EXPIRED: Request for commercial pricing',
      };

      const response = await fetch(CONTACT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(messageInfo),
      });

      if (!response.ok) {
        throw new Error('Failed to send pricing request');
      }

      return {
        success: true,
        message: 'Your pricing request has been sent successfully',
      };
    } catch (error) {
      console.error('Error requesting pricing:', error);
      return {
        success: false,
        message: 'There was an error sending your pricing request. Please try again.',
        error: error instanceof Error ? error.message : 'Unknown error',
      };
    }
  }
}

export default new RequestPricingService();